<template>
  <div>
    <div
    v-lazy-container="{ selector: 'img', loading: loader }"
    class="game-item position-relative"
    :title="game.name"
    :class="game.system+'_game'"
    @click.prevent.stop="gotoGameView">
    <img :alt="'VipMagnit казино  '+ game.name"
         :data-src="game.picture" :src="game.picture"
         class="game-img">
    <div class="game-hovered">
      <div class="game-actions">
        <a class="playbtn py-2 mx-auto d-inline-block w-100 px-2 text-center" @click.prevent.stop="gotoGameView">
          <h6 class="my-0 px-1 game-title"> {{ game.name }} </h6>
          <button class="btn main-btn mx-auto py-1 px-4 mt-4" :title="'Играть в '+ game.name">Играть</button>
        </a>
        <div :ref="game.system+'_'+game.id"
             @click.prevent.stop="gameIsFavorite ? removeGameFromFavorites(game) : addGameToFavorites(game)"
            class="text-center">
          <span  class="add-game-to-favorites"  :class="gameIsFavorite ? 'is-favorite-game':'not-favorite-game'">
              {{gameIsFavorite ? 'Удалить из избранных':'Добавить в избранные'}}
              <i v-if="!favoriteGameIsSubmitting" class="fa fa-star-o"></i>
              <i v-else class="fa fa-spin fa-spinner"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="game-name">
     <span>{{ game.name }}</span>
  </div>
  </div>
</template>

<script>
export default {
  name: 'GamePreview',
  props: ['game', 'img', 'gameIsFavorite'],
  data () {
    return {
      favoriteGameIsSubmitting: false,
           loader : require('@/../public/images/icons/main-loader.svg')
    }
  },
  computed: {
    isMobile () {
      return this.$_config.environment.mobile
    }
  },
  methods: {
    addGameToFavorites (game) {
      if (!this.$store.getters.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Действия доступно авторизованным клиентам')
      }
      this.favoriteGameIsSubmitting = true

      const formData = new FormData();
      formData.append('game', game.id);
      formData.append('system', game.system);
      formData.append('params', JSON.stringify(game));

      this.axios.post(
        this.$_config.baseUrl + '/Api/addGameToFavorites',
          formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(({ data }) => {
        this.favoriteGameIsSubmitting = false

        if (data.status) {
          if (data.status === 'ok') {
            this.$root.$emit('addGameToFavorites', this.game)
          } else {
            this.$root.$emit('modalAlertMessage', { msg: data.msg, status: data.status })
            return this.$root.$emit('bv::show::modal', 'modalAlert')
          }
        } else {
          this.$root.$emit('modalAlertMessage', { msg: 'Действие не может быть выполнено.Пожалуйста, сообщите об этом в контактную службу', status: 'error' })
          return this.$root.$emit('bv::show::modal', 'modalAlert')
        }
      }).catch((err) => {
        if (err) {
          console.log(err)
        }
      })
    },
    removeGameFromFavorites (game) {
      if (!this.$store.getters.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Действия доступно авторизованным клиентам')
      }
      this.favoriteGameIsSubmitting = true

      const formData = new FormData();
      formData.append('game', game.id);
      formData.append('system', game.system);

      this.axios.post(
        this.$_config.baseUrl + '/Api/removeGameFromFavoriteList',
          formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(({ data }) => {
        this.favoriteGameIsSubmitting = false
        if (data.status) {
            this.$root.$emit('modalAlertMessage', { msg: data.msg, status: data.status })
          this.$store.dispatch('fetchGamesByProviders', 'favorites')
            return this.$root.$emit('bv::show::modal', 'modalAlert')
        } else {
          this.$root.$emit('modalAlertMessage', { msg: 'Действие не может быть выполнено.Пожалуйста, сообщите об этом в контактную службу', status: 'error' })
          return this.$root.$emit('bv::show::modal', 'modalAlert')
        }
      }).catch((err) => {
        if (err) {
          console.log(err)
        }
      })
    },
    gotoGameView () {
      if (!this.$store.getters.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для запуска игры нужно авторизоваться')
      }
      const gameName = this.game.name.split(' ').join('-')

      if (this.isMobile) {
        return this.$router.push({
          name: 'LaunchGameMobile',
          params: {
            gameName: gameName,
            gameId: this.game.id,
            game: this.game,
            provider: this.game.system,
            isLive: this.game.isLive,
            restoring: false
          }
        })
      }
      return this.$router.push({
        name: 'LaunchGame',
        params: {
          gameName: gameName,
          gameId: this.game.id,
          game: this.game,
          provider: this.game.system,
          isLive: this.game.isLive,
          restoring: false
        }
      })
    }
  }
}
</script>

<style scoped>
  .add-game-to-favorites,.fa-spinner{
    font-size: 14px;
  }
  .not-favorite-game{
    color: #979797;
  }
  .is-favorite-game{
    color: #7eff15;
  }
  .is-favorite-game:hover{
    color: red;
  }
  .not-favorite-game:hover{
    color: #7eff15;
  }
  .fa-star-o:before {
    content: "\f006";
  }
  .game-title{
    color: #ffffff;
    font-weight: 600;
  }
  .game-hovered{
    display: block;
    height: 0;
    top: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }
  .game-name{
    display: flex;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .game-item{
    cursor: pointer;
    border: 1px solid #30353b;
    margin: .125em;
    transition: 0.4s;
   }

  .game-item:hover{
    transition: 0.4s;
  }
  .game-item:hover .game-hovered{
    transition: 0.4s;
    display: flex;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0a1123e3;
    border: 1px solid #30353b;
  }
  .game-actions{
    margin: auto;
  }
  .game-item img[lazy='loading'] {
    object-fit: contain !important;
  }

  .game-item .game-img{
    width: 100%;
    height: 220px;
    background-color: #080d13;
    object-fit: contain;
  }
</style>
